import { ColdLeadsMap } from "./candidatesMasterAction";

const initialState = {
  isLoading: false,
  coldLeadsList: {},
  refreshColdLeadsList: true,
  searchBy: "",
  searchText: "",
  skip: 0,
  limit: 10,
  selectedColdLead: {},
  audioType: "all",
  batchFilter: "",
  dateFilter: "",
  leadType: "all",
  callOutcomeFilter: "all",
  batchNames: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ColdLeadsMap.GET_ALL_COLD_LEADS_START:
      return {
        ...state,
        isLoading: true,
      };
    case ColdLeadsMap.GET_ALL_COLD_LEADS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coldLeadsList: action.payload,
        refreshColdLeadsList: false,
      };
    case ColdLeadsMap.GET_ALL_COLD_LEADS_ERROR:
      return {
        ...state,
        isLoading: false,
        refreshColdLeadsList: false,
      };
    case ColdLeadsMap.SEARCH_TEXT_CHANGE:
      return {
        ...state,
        searchText: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case ColdLeadsMap.SET_COLD_LEADS_BATCH_NUMBER:
      return {
        ...state,
        skip: action.payload,
        refreshColdLeadsList: true,
      };
    case ColdLeadsMap.GET_COLD_LEAD_START:
      return {
        ...state,
        isLoading: true,
      };
    case ColdLeadsMap.GET_COLD_LEAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedColdLead: action.payload,
      };
    case ColdLeadsMap.GET_COLD_LEAD_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case ColdLeadsMap.SET_AUDIO_TYPE:
      return {
        ...state,
        audioType: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case ColdLeadsMap.SET_BATCH_FILTER:
      return {
        ...state,
        batchFilter: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case ColdLeadsMap.SET_DATE_FILTER:
      return {
        ...state,
        dateFilter: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case ColdLeadsMap.SET_LEAD_TYPE:
      return {
        ...state,
        leadType: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case ColdLeadsMap.SET_CALL_OUTCOME_FILTER:
      return {
        ...state,
        callOutcomeFilter: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case ColdLeadsMap.SET_LIMIT:
      return {
        ...state,
        limit: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    default:
      return state;
  }
};


